export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filter.vue?vue&type=template&id=6c4b96c1&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/filter/filter.vue?vue&type=template&id=6c4b96c1&
// module id = 940
// module chunks = 0